import { render, staticRenderFns } from "./forgotpass.vue?vue&type=template&id=13b813a0"
import script from "./forgotpass.vue?vue&type=script&lang=js"
export * from "./forgotpass.vue?vue&type=script&lang=js"
import style0 from "./forgotpass.vue?vue&type=style&index=0&id=13b813a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports